export default "__VITE_ASSET__CBYPr39E__"